import Sequence from './Sequence';

export default Sequence;